export default __webpack_public_path__ + "static/media/bg.11684cda.png";